export default class FeaUtils {

  static ExtractValuesFromCSV(csvText: string): { [key: number]: number } {
    var valuesPerElement: { [key: number]: number } = {};
    csvText.split(/\r\n|\n|\r/).forEach(row => {
      var values = row.split(',')
      valuesPerElement[Number(values[0])] = Number(values[1])
    });
    return valuesPerElement
  }

  static formatFeaNumber(value: number): number {
    // Replicate the backend C# logic: Math.Abs(kv.Value) > 0 && Math.Abs(kv.Value) < 0.01 ? kv.Value.ToString("0.##E+0") : Math.Round(kv.Value, 2).ToString()
    const absValue = Math.abs(value);

    if (absValue === 0) {
      return 0;
    }

    if (absValue < 0.01) {
      // For very small numbers, we need to preserve them but clean up floating point precision
      // We'll round to a reasonable number of significant digits
      const magnitude = Math.floor(Math.log10(absValue));
      const significantDigits = Math.max(2, -magnitude + 1);
      const factor = Math.pow(10, significantDigits);
      return Math.round(value * factor) / factor;
    }

    // For larger numbers, round to 2 decimal places
    return Math.round(value * 100) / 100;
  }

}
